const isNil = (val: any): boolean => {
  return val == null;
};

export default isNil;
